import React, {useState} from "react";
import {Box, Button, Modal, Typography, useMediaQuery} from "@mui/material";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {toggleFlyerDetailsPopup} from "../../../store/actionCreators/toggleActionForEditorActionCreators";
import {useDispatch} from "react-redux";
import {makeStyles} from "@mui/styles";
import {startUploadingImagesProgressPopup} from "../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {createFlyerFromPdfFile} from "../../../store/actionCreators/flyerFromPdfActionCreator";
import {ReactComponent as UploadPDFIcon} from "../../../assets/createNewFlyerModal/upload_pdf_icon.svg";
import {ReactComponent as UploadJPEGsIcon} from "../../../assets/createNewFlyerModal/upload_jpegs_icon.svg";
import {ReactComponent as EmptyPagesIcon} from "../../../assets/createNewFlyerModal/empty_pages_icon.svg";
import {CreateFlyerWithEmptyPages} from "./createFlyerWithEmptyPages";
import {PopupHeader} from "../../com/popupHeader/popupHeader";
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";
import {UserDto} from "../../../dtos";
import {CreateFlyerWithJpegsPages} from "./createFlyerWithJpegsPages";

const useStyles = makeStyles(() => ({
    createNewFlyerBtnWrapper: {
        display: `flex`,
        flexFlow: `row`,
        alignItems: `center`,
        columnGap: `2%`
    },
    uploadButton: {
        display: "flex",
        flexFlow: "column",
        rowGap: "32px",
        '&.MuiButtonBase-root': {
            padding: `32px 0`,
            height: `100%`,
            flex: `1 1 auto`,
            // width: `100%`,
            // height: `64px`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            border: `2px dashed #888888`,
            borderRadius: `0`,
            boxShadow: `none`,
            backgroundColor: `#ffffff`,
            '&:hover': {
                backgroundColor: `#ffffff`,
                boxShadow: `none`
            }
        }
    },

}))


export const CreateFlyerModal = () => {
    const dispatch = useDispatch();
    const isXs = useMediaQuery(`(max-width:699px)`);
    const flyersState = useTypedSelector((state) => state.flyers);

    let {isShowCreateNewFlyerPopup} = useTypedSelector((state) => state.toggleActionsForFlyers);
    let flyerDataWithoutImages = useTypedSelector((state) => state.flyerDataWithoutImages);

    const [isOpenCreateEmptyFlyer, setOpenCreateEmptyFlyer] = useState<boolean>(false);
    const [isOpenCreateNewJpegFlyer, setOpenCreateNewJpegFlyer] = useState<boolean>(false);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isAccountTier1 = userDto?.accountTier === 1;


    const classes = useStyles();

    const onClosePopup = () => {
        dispatch(toggleFlyerDetailsPopup(false));
    }

    const onPDFSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];
        dispatch(startUploadingImagesProgressPopup());
        dispatch(createFlyerFromPdfFile(file, false, flyersState));
    }

    const createEmptyPagesForFlyer = () => {
        setOpenCreateEmptyFlyer(true);
    }

    const onClickJpegFlyerBtn = () => {
        setOpenCreateNewJpegFlyer(true);
    }

    return (
        <>
            <Modal open={isShowCreateNewFlyerPopup} disableScrollLock={true}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isXs ? `90vw` : `25vw`,
                        minWidth: isXs ? "auto" : `420px`,
                        maxWidth: `90vw`,
                        backgroundColor: `#ffffff`,
                        display: "flex",
                        flexFlow: "column",
                        maxHeight: `90vh`,
                    }}
                >
                    {
                        flyerDataWithoutImages.loading &&
                        <Box
                            sx={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                background: "#ffffffB3",
                                zIndex: "1",
                            }}
                        >
                            <PageSpinner/>
                        </Box>
                    }

                    <PopupHeader onClose={onClosePopup} headerCaption={"Create New Flyer"}/>
                    <Box sx={{
                        padding: "20px",
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "8px",
                    }}>
                        <Box className={classes.createNewFlyerBtnWrapper} >
                            <Button
                                variant={`contained`}
                                component="label"
                                className={classes.uploadButton}
                            >
                                <UploadPDFIcon style={{margin: `5px 0 10px`}}/>
                                <Typography color={`#000000`} mx={`32px`}>
                                    Upload one PDF file for flyer
                                </Typography>
                                <input
                                    type="file"
                                    accept={`.pdf`}
                                    multiple={false}
                                    onChange={onPDFSelected}
                                    hidden
                                />
                            </Button>
                        </Box>
                        {
                            !isAccountTier1 &&
                            <>
                                <Typography textAlign={"center"}>
                                    or
                                </Typography>
                                <Box className={classes.createNewFlyerBtnWrapper} >
                                    <Button
                                        className={classes.uploadButton}
                                        onClick={onClickJpegFlyerBtn}
                                    >
                                        <UploadJPEGsIcon style={{margin: `5px 0 10px`}}/>
                                        <Typography color={`#000000`} mx={`10px`}>
                                            Upload JPG files, one per page
                                        </Typography>
                                    </Button>
                                    {/*<Button*/}
                                    {/*    variant={`contained`}*/}
                                    {/*    component="label"*/}
                                    {/*    className={classes.uploadButton}*/}
                                    {/*>*/}
                                    {/*    <UploadJPEGsIcon style={{margin: `5px 0 10px`}}/>*/}
                                    {/*    <Typography color={`#000000`} mx={`10px`}>*/}
                                    {/*        Upload JPG files, one per page*/}
                                    {/*    </Typography>*/}
                                    {/*    <input*/}
                                    {/*        type="file"*/}
                                    {/*        accept={`.jpg, .jpeg`}*/}
                                    {/*        multiple={true}*/}
                                    {/*        onChange={onJpegsSelected}*/}
                                    {/*        hidden*/}
                                    {/*    />*/}
                                    {/*</Button>*/}
                                </Box>
                                <Typography textAlign={"center"}>
                                    or
                                </Typography>
                                <Box className={classes.createNewFlyerBtnWrapper} >
                                    <Button
                                        onClick={createEmptyPagesForFlyer}
                                        variant={`contained`}
                                        // component="label"
                                        className={classes.uploadButton}

                                    >
                                        <EmptyPagesIcon style={{margin: `5px 0 10px`}}/>
                                        <Typography color={`#000000`} mx={`10px`}>
                                            Create a blank flyer
                                        </Typography>
                                    </Button>
                                </Box>
                            </>
                        }
                    </Box>
                </Box>
            </Modal>
            {
                isOpenCreateEmptyFlyer &&
                <CreateFlyerWithEmptyPages isOpen={isOpenCreateEmptyFlyer} setIsOpen={setOpenCreateEmptyFlyer}/>
            }
            {
                isOpenCreateNewJpegFlyer &&
                <CreateFlyerWithJpegsPages isOpen={isOpenCreateNewJpegFlyer} setIsOpen={setOpenCreateNewJpegFlyer}/>
            }
        </>
    )
}